const classificationType = {
  UnidentifiedObject: 'Unidentified Object',
  Structure: 'Structure',
  HumanGathering: 'Human Gathering',
  TemporaryStructure: 'Temporary Structure',
  MechanicalEquipment: 'Mechanical Equipment',
  PotentialLeak: 'Potential Leak',
};

export default {
  class: {
    commercialTruck: 'Commercial Truck',
    duplicate: 'Duplicate',
    falsePositive: 'False Positive',
    humanGathering: 'Human Gathering',
    mechanicalEquipment: 'Mechanical Equipment',
    movable: 'Movable',
    oversizedPassengerVehicle: 'Oversized Passenger Vehicle',
    personalProperty: 'Personal Property',
    potentialLeak: 'Potential Leak',
    recreationalOffroadVehicle: 'Recreational Offroad Vehicle',
    regularPassengerVehicle: 'Regular Passenger Vehicle',
    structure: 'Structure',
    temporaryStructure: 'Temporary Structure',
    unidentifiedObject: 'Unidentified Object',
    unknown: 'Unknown',
    tileDrainage: 'Tile Drainage',
    exposedPipe: 'Exposed Pipe',
  },
  classificationType,
  type: {
    dismissed: 'Dismissed',
    immediate: 'Immediate',
    investigation: 'Investigation',
    noteAutomatic: 'Note Automatic',
    noteManual: 'Note Manual',
    unclassified: 'Unclassified',
  },
};
